import { Component } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { RouterOutlet } from '@angular/router';
import { VERSION } from 'src/environments/version';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
})
export class AppComponent {
  title = 'agent-iframe';
  constructor(private meta: Meta) {
    this.meta.updateTag({
      name: 'app-version',
      content: VERSION,
    });
  }
}
